import Footer from 'src/components/Footer'
import Header from 'src/components/Header'
import NextBreadcrumb from '../NextBreadcrumb'

export function NewsLayout({ hideBreadcrumb, children }) {
	return (
		<>
			<Header />
			<div className="container">
				<NextBreadcrumb rootLabel={'Trang chủ'} />
			</div>
			<div>{children}</div>
			<Footer />
		</>
	)
}

export default NewsLayout
